module.exports = __webpack_public_path__ + "img/82800.b7f17681.jpg";